import {Component, OnInit} from '@angular/core';
import {RestApiService} from '../../../../services/api';
import {ToastService} from '../../../../services/toast.service';
import {ConfirmationService} from 'primeng/api';
import { InputComponent } from '../../../../components/form/input/input.component';
import { ButtonDirective } from 'primeng/button';
import { Ripple } from 'primeng/ripple';

@Component({
    selector: 'app-massive-ticket-sender',
    templateUrl: './massive-ticket-sender.component.html',
    styleUrls: ['./massive-ticket-sender.component.scss'],
    imports: [InputComponent, ButtonDirective, Ripple]
})
export class MassiveTicketSenderComponent implements OnInit {

    textualLogins = '';
    title = '';
    message = '';

    constructor(private api: RestApiService,
                private toast: ToastService,
                private confirmDialog: ConfirmationService) {
    }

    ngOnInit(): void {
    }

    createTickets() {
        const logins: string[] = this.textualLogins.split(/\n/g).filter(x => x.trim().length > 0);
        if (logins.length === 0) {
            this.toast.error('Errore', 'Nessuna login immessa');
            return;
        }
        if (this.message.trim().length === 0) {
            this.toast.error('Errore', 'Nessun testo immesso');
            return;
        }
        this.confirmDialog.confirm({
            message: 'Sei sicuro di voler procedere con l\'apertura dei ticket?<br>Azione non reversibile.',
            header: 'Attenzione',
            acceptLabel: 'Conferma',
            rejectLabel: 'Annulla',
            accept: async () => {
                const response = await this.api.tickets.createClientTicketBulk({
                    logins: logins,
                    title: this.title,
                    message: this.message,
                });
                this.toast.success('Ticket aperti', `Sono stati creati ${response.data} tickets.`);
            }
        });
    }

}
